const { locationIdToProperties } = require('../../../tools')
const tools = require('../../tools')
const { getLocationsWithConfigurations } = require('./configuration-docs')

const getLocationDoc = async (state, params, date, includeProgramsHistory = false) => {
  const funderOrRouteFilter = tools.getUserFilter(state.user)
  const isoDate = new Date(date).toJSON()
  const doc = await state.dal.location.getRawDoc(state, params)

  const [location] = await getLocationsWithConfigurations(state, [doc], {
    date: isoDate,
    funderOrRouteFilter,
    includeProgramsHistory
  })
  return location
}

exports.get = getLocation
function getLocation (state, locationId, date, includeProgramsHistory = false) {
  return getLocationDoc(state, {locationId}, date, includeProgramsHistory)
}

exports.getByWarehouseCode = getByWarehouseCode
async function getByWarehouseCode (state, warehouseCode, date) {
  return getLocationDoc(state, {warehouseCode}, date)
}

exports.getBySignupUid = async function getBySignupUid (state, signupUid) {
  return state.dal.location.getRawDocBySignupUid(state, signupUid)
}

// Old PSM hack: no state locations exist to display, fake name
exports.getOrFakeName = getOrFakeName
async function getOrFakeName (state, locationId, date) {
  const location = await getLocation(state, locationId, date)
  if (location) return location

  const locationProperties = locationIdToProperties(locationId)
  return {fullName: locationProperties[locationProperties.level]}
}
